import { Download } from "lucide-react";
import { useLocale } from "../../../context/LanguageContext";

const API_BASE =
  import.meta.env.VITE_GRAPHQL_URL?.replace("/graphql", "") ||
  "http://localhost:4000";

export function DownloadTemplateButton() {
  const { t } = useLocale();
  return (
    <a
      href={`${API_BASE}/templates/roster-template.csv`}
      download="roster-template.csv"
      className="inline-flex items-center gap-2 rounded-md border border-border px-3 py-1.5 text-xs font-medium text-foreground transition-colors hover:bg-muted"
    >
      <Download className="h-3.5 w-3.5" />
      {t("roster.downloadTemplate")}
    </a>
  );
}
